'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LeftMenu$InternalLink(page, label, isNew) {
  this.CD = null;
  this.CC = null;
  this.CB = false;
  this.CD = page;
  this.CC = label;
  this.CB = isNew;
}
export { $c_Lpresto_LeftMenu$InternalLink as $c_Lpresto_LeftMenu$InternalLink };
$p = $c_Lpresto_LeftMenu$InternalLink.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LeftMenu$InternalLink;
/** @constructor */
function $h_Lpresto_LeftMenu$InternalLink() {
}
export { $h_Lpresto_LeftMenu$InternalLink as $h_Lpresto_LeftMenu$InternalLink };
$h_Lpresto_LeftMenu$InternalLink.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("InternalLink"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.CD));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.CC));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.CB ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 3);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_LeftMenu$InternalLink)) {
    if ((this.CB === x$0.CB)) {
      var x = this.CD;
      var x$2 = x$0.CD;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.CC === x$0.CC);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "InternalLink";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.CD;
      break;
    }
    case 1: {
      return this.CC;
      break;
    }
    case 2: {
      return this.CB;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_LeftMenu$InternalLink(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iv)));
}
export { $isArrayOf_Lpresto_LeftMenu$InternalLink as $isArrayOf_Lpresto_LeftMenu$InternalLink };
var $d_Lpresto_LeftMenu$InternalLink = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LeftMenu$InternalLink, "presto.LeftMenu$InternalLink", ({
  iv: 1,
  iw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_LeftMenu$InternalLink as $d_Lpresto_LeftMenu$InternalLink };
//# sourceMappingURL=presto.-Left-Menu$-Internal-Link.js.map
